module.exports = __webpack_public_path__ + "static/assets/576a1103506ec80bd274c7bc5f586a7e.png";